import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '@app/shared';
import { FlexModule } from 'ngx-flexible-layout';

import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileComponent } from './profile.component';
import { PictureDialogComponent } from './picture-dialog/picture-dialog.component';
import { AvatarModule } from '@app/shared/avatar/avatar.module';
import { MatMenuModule } from '@angular/material/menu';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,
    FlexModule,
    ImageCropperModule,
    AmplifyUIAngularModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTooltipModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatInputModule,
    MatFormFieldModule,
    ProfileRoutingModule,
    AvatarModule,
    SharedModule,
  ],
  declarations: [
    ProfileComponent,
    PictureDialogComponent,
    ChangePasswordComponent,
  ],
})
export class ProfileModule {}
